export const ACCOUNT_USER_ACESSES = {
  ADMIN: 'accountAdmin',
  EXECUTIVE: 'executive',
};
